import { minLength, required, TextInput } from 'react-admin';
import { SimpleForm } from '@components/SimpleForm';
import { Grid } from '@mui/material';

export const SettingForm = () => {
    return (
        <SimpleForm>
            <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                    <TextInput
                        source="name"
                        validate={[required(), minLength(2)]}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextInput source="val" validate={[required()]} />
                </Grid>
            </Grid>
        </SimpleForm>
    );
};
